const getDefaultState = () => {
  return {
    displayFoa: true,
    displayMinFuel: false,
    displayBestTce: false,
    displayBestDta: false,
    displayMinTime: false,
    displaySolutionsMesh: true,
    openedPanels: [0],
  };
};

const state = getDefaultState();

//TODO: Unecessary getters, remove them use state instead (wrote it like this when I was still learning)
const getters = {
  getDisplayFoa: (state) => (state.displayFoa),
  getDisplayMinFuel: (state) => (state.displayMinFuel),
  getDisplayTce: (state) => (state.displayBestTce),
  getDisplayDta: (state) => (state.displayBestDta),
  getDisplayMinTime: (state) => (state.displayMinTime),
  getOpenedPanels: (state) => (state.openedPanels),
  getFoaLineLayer: (state) => {
    return {
      id: "foaLine",
      type: "line",
      layout: {
        "line-cap": "butt",
        "visibility": state.displayFoa ? "visible" : "none"
      },
      paint: {
        "line-color": "#FFFFFF",
        "line-width": 6,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
  getFoaPointsLayer: (state) => {
    return {
      id: "foaPoints",
      type: "circle",
      paint: {
        "circle-radius": 5.5,
        "circle-color": "#BDBDBD",
        "circle-stroke-width": 1,
        "circle-stroke-color": "#FFFFFF",
      },
      "layout": {
        visibility: state.displayFoa ? "visible" : "none",
      },
      filter: ["==", "$type", "Point"],
    };
  },
  getMinFuelLineLayer: (state) => {
    return {
      id: "minFuelLine",
      type: "line",
      layout: {
        "line-cap": "butt",
        "visibility": state.displayMinFuel ? "visible" : "none"
      },
      paint: {
        "line-color": "#00DD23",
        "line-width": 6,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
  getMinFuelPointsLayer: (state) => {
    return {
      id: "minFuelPoints",
      type: "circle",
      paint: {
        "circle-radius": 5.5,
        "circle-color": "#00DD23",
        "circle-stroke-width": 0.5,
        "circle-stroke-color": "#000000",
        "circle-stroke-opacity": 0.5,
      },
      "layout": {
        visibility: state.displayMinFuel ? "visible" : "none",
      },
      filter: ["==", "$type", "Point"],
    };

  },
  getMinTimeLineLayer: (state) => {
    return {
      id: "minTimeLine",
      type: "line",
      layout: {
        "line-cap": "butt",
        "visibility": state.displayMinTime ? "visible" : "none"
      },
      paint: {
        "line-color": "#FFFF00",
        "line-width": 6,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
  getMinTimePointsLayer: (state) => {
    return {
      id: "minTimePoints",
      type: "circle",
      paint: {
        "circle-radius": 5.5,
        "circle-color": "#FFFF00",
        "circle-stroke-width": 0.5,
        "circle-stroke-color": "#000000",
        "circle-stroke-opacity": 0.5,
      },
      "layout": {
        visibility: state.displayMinTime ? "visible" : "none",
      },
      filter: ["==", "$type", "Point"],
    };

  },
  getBestTceLineLayer: (state) => {
    return {
      id: "bestTceLine",
      type: "line",
      layout: {
        "line-cap": "butt",
        visibility: state.displayBestTce ? "visible" : "none",
      },
      paint: {
        "line-color": "#FFA726",
        "line-width": 6,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
  getBestTcePointsLayer: (state) => {
    return {
      id: "bestTcePoints",
      type: "circle",
      paint: {
        "circle-radius": 5.5,
        "circle-color": "#FFA726",
        "circle-stroke-width": 0.5,
        "circle-stroke-color": "#000000",
        "circle-stroke-opacity": 0.5,
      },
      "layout": {
        visibility: state.displayBestTce ? "visible" : "none",
      },
      filter: ["==", "$type", "Point"],
    };
  },
  getBestDtaLineLayer: (state) => {
    return {
      id: "bestDtaLine",
      type: "line",
      layout: {
        "line-cap": "butt",
        "visibility": state.displayBestDta ? "visible" : "none"
      },
      paint: {
        "line-color": "#E65100",
        "line-width": 6,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
  getBestDtaPointsLayer: (state) => {
    return {
      id: "bestDtaPoints",
      type: "circle",
      layout: {
        "visibility": state.displayBestDta ? "visible" : "none"
      },
      paint: {
        "circle-radius": 5.5,
        "circle-color": "#E65100",
        "circle-stroke-width": 0.5,
        "circle-stroke-color": "#000000",
        "circle-stroke-opacity": 0.5,
      },
      filter: ["==", "$type", "Point"],
    };
  },
  getHighPointsLayer: (state) => {
    return {
      id: "highPoints",
      type: "circle",
      layout: {
        // using display foa for now, will change it to its own bool later
        "visibility": state.displaySolutionsMesh ? "visible" : "none"
      },
      paint: {
        "circle-radius": 3.5,
        "circle-color": "#9C27B0",
        "circle-stroke-width": 0.5,
        "circle-stroke-color": "#9C27B0",
        "circle-stroke-opacity": 0.5,
      },
      filter: ["==", "$type", "Point"],
    };
  },
  getLowPointsLayer: (state) => {
    return {
      id: "lowPoints",
      type: "circle",
      layout: {
        // using display foa for now, will change it to its own bool later
        "visibility": state.displaySolutionsMesh ? "visible" : "none"
      },
      paint: {
        "circle-radius": 3.5,
        "circle-color": "#9C27B0",
        "circle-stroke-width": 0.5,
        "circle-stroke-color": "#9C27B0",
        "circle-stroke-opacity": 0.5,
      },
    };
  },
  getHighLineLayer: (state) => {
    return {
      id: "highLine",
      type: "line",
      layout: {
        // using display foa for now, will change it to its own bool later
        "visibility": state.displaySolutionsMesh ? "visible" : "none",

      },
      paint: {
        "line-color": "#E1BEE7",
        "line-width": 3,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
  getLowLineLayer: (state) => {
    return {
      id: "lowLine",
      type: "line",
      layout: {
        // using display foa for now, will change it to its own bool later
        "visibility": state.displaySolutionsMesh ? "visible" : "none",
      },
      paint: {
        "line-color": "#E1BEE7",
        "line-width": 3,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
};

const actions = {
  toggleDisplayFoa({ commit }) {
    commit("SET_DISPLAY_FOA", !state.displayFoa);
  },

  toggleDisplayMinFuel({ commit }) {
    commit("SET_DISPLAY_MIN_FUEL", !state.displayMinFuel);
  },
  toggleDisplayBestTce({ commit }) {
    commit("SET_DISPLAY_TCE", !state.displayBestTce);
  },
  toggleDisplayBestDta({ commit }) {
    commit("SET_DISPLAY_DTA", !state.displayBestDta);
  },
  toggleDisplayMinTime({ commit }) {
    commit("SET_DISPLAY_MIN_TIME", !state.displayMinTime);
  },
  toggleDisplaySolutionsMesh({ commit }) {
    commit("SET_DISPLAY_SOLUTIONS_MESH", !state.displaySolutionsMesh);
  },
  togglePanel({ commit }, index) {
    if (state.openedPanels.includes(index)) {
      const panel = state.openedPanels.indexOf(index);
      state.openedPanels.splice(panel, 1);
      commit("SET_OPENED_PANELS", state.openedPanels);
    } else {
      state.openedPanels.push(index);
      commit("SET_OPENED_PANELS", state.openedPanels);
    }
  },
};

const mutations = {
  SET_DISPLAY_FOA: (state, data) => (state.displayFoa = data),
  SET_DISPLAY_MIN_FUEL: (state, data) => (state.displayMinFuel = data),
  SET_DISPLAY_TCE: (state, data) => (state.displayBestTce = data),
  SET_DISPLAY_DTA: (state, data) => (state.displayBestDta = data),
  SET_DISPLAY_MIN_TIME: (state, data) => (state.displayMinTime = data),
  SET_OPENED_PANELS: (state, data) => (state.openedPanels = data),
  SET_DISPLAY_SOLUTIONS_MESH: (state, data) => (state.displaySolutionsMesh = data),
  RESET_STATE: (state) => Object.assign(state, getDefaultState())
};

export const weatherRoutingMapModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
